export const CLOSE_MODAL = "BUG REPORT > CLOSE MODAL";

export const INVOKE_MODAL = "BUG REPORT > INVOKE MODAL";

export const CHANGE_MESSAGE = "BUG REPORT > CHANGE MESSAGE";

export const PUSH_ERROR_TO_STACK = "BUG_REPORT > PUSH ERROR TO STACK";
export const REMOVE_ERROR_TO_STACK = "BUG_REPORT > REMOVE ERROR TO STACK";

export const SUBMIT_REPORT_REQUEST = "BUG_REPORT > REQUEST";
export const SUBMIT_REPORT_SUCCESS = "BUG_REPORT > SUCCESS";
export const SUBMIT_REPORT_ERROR = "BUG_REPORT > ERROR";
